export const byte = 1;
export const KB = 1024 * byte;
export const MB = 1024 * KB;
export const GB = 1024 * MB;
